import React, {FC, useState} from "react";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Drawer, Space, Tooltip} from "antd";
import {EyeOutlined, ReloadOutlined} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import EmailModel from "../../models/emails/email-model";
import {useAxios} from "../../utils/hooks";
import {openNotification} from "../../utils/openNotification";

const EmailsScreen: FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [trigger, setTrigger] = useSafeState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [selectedEmailBody, setSelectedEmailBody] = useState<string>("");
    const [selectedEmailSubject, setSelectedEmailSubject] = useState<string>("");

    const handleViewEmail = (record: any) => {
        setSelectedEmailBody(record.body || "");
        setSelectedEmailSubject(record.subject || "");
        setDrawerVisible(true);
    };

    const handleRetryEmail = (record: any) => {
        if (axiosInstance.current != null) {
            axiosInstance.current
                .post('/resource/emails/' + encodeURIComponent(record.id) + '/retry')
                .then(() => {
                    openNotification('customSuccess', 'Email status reset to CREATED. It will be retried on next scheduler run.');
                    setTrigger(function(prev) { return !prev; });
                })
                .catch(function (error: any) {
                    openNotification('error', error);
                });
        }
    };

    const action = (record: any) => {
        return (
            <>
                <Tooltip title={<Trans>View Email</Trans>}>
                    <EyeOutlined 
                        className={"ActionButtons"} 
                        style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff' }}
                        onClick={() => handleViewEmail(record)}
                    />
                </Tooltip>
                {record.status === 'ERROR' && (
                    <Tooltip title={<Trans>Retry Email</Trans>}>
                        <ReloadOutlined 
                            className={"ActionButtons"} 
                            style={{ fontSize: '18px', cursor: 'pointer', color: '#52c41a', marginLeft: 8 }}
                            onClick={() => handleRetryEmail(record)}
                        />
                    </Tooltip>
                )}
            </>
        )
    };

    const actions = {
        width: 150,
        render: (text: string, record: any) => action(record),
        title: <Trans>Actions</Trans>,
        fixed: 'right',
        align: 'center'
    };

    return (
        <>
            <Breadcrumb style={{marginBottom: 10}}>
                <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'Emails'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            
            <DtoTable
                model={EmailModel}
                trigger={trigger}
                allowRefreshButton={true}
                allowExport={true}
                pageSize={100}
                scroll={{x: 1800, y: "65vh"}}
                action={actions}
            />

            <Drawer
                title={selectedEmailSubject}
                placement="right"
                onClose={() => setDrawerVisible(false)}
                visible={drawerVisible}
                width={800}
            >
                <div 
                    dangerouslySetInnerHTML={{ __html: selectedEmailBody }}
                    style={{ 
                        padding: '20px',
                        backgroundColor: '#fff',
                        border: '1px solid #f0f0f0',
                        borderRadius: '4px'
                    }}
                />
            </Drawer>
        </>
    )
}

export default EmailsScreen;
